import packages from '../../package.json';

// ==============================|| PATH ||============================== //

function path(root, sublink) {
  return `${root}${sublink}`;
}

// ==============================|| ROOT ||============================== //

const ROOTS_AUTH = '/auth';
const ROOTS_HONHAI = '/honhai';
const ROOTS_LABOR = '/labor';

// ==============================|| PATH ROUTER ||============================== //

export const PATH_CONFIG = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  basename: packages.homepage,
  permissions: [
    '/403',
    '/400',
    '/500',
    '/login',
    '/register',
    '/forget-password',
    '/setting-password',
    '/sso-authorize',
    '/under-construction',
    path(ROOTS_HONHAI, '/law-trademark'),
    path(ROOTS_HONHAI, '/specification'),
    path(ROOTS_HONHAI, '/privacy-policy'),
    path(ROOTS_HONHAI, '/cookie-policy'),
    path(ROOTS_HONHAI, '/app')
  ]
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_HONHAI = {
  root: ROOTS_HONHAI,

  general: {
    app: path(ROOTS_HONHAI, '/app'),
    service: path(ROOTS_HONHAI, '/service'),
    resourceDownload: path(ROOTS_HONHAI, '/resource-download'),
    faqs: path(ROOTS_HONHAI, '/faqs'),
    feedback: path(ROOTS_HONHAI, '/feedback'),
  },
  service: {
    root: path(ROOTS_HONHAI, '/service'),
    analytics: path(ROOTS_HONHAI, '/service-analytics'),
    catering: path(ROOTS_HONHAI, '/service-analytics/catering'),
    clean: path(ROOTS_HONHAI, '/service-analytics/clean'),
    postal: path(ROOTS_HONHAI, '/service-analytics/postal'),
    repair: path(ROOTS_HONHAI, '/service-analytics/repair'),
  },

  about: {
    root: path(ROOTS_HONHAI, '/about'),
    introduce: path(ROOTS_HONHAI, '/about/business-introduce'),
    contact: path(ROOTS_HONHAI, '/about/factory-contact'),
    stationary: path(ROOTS_HONHAI, '/about/stationary-position'),

    analytics: path(ROOTS_HONHAI, '/about-analytics'),
    businessIntroduce: path(ROOTS_HONHAI, '/about-analytics/business-introduce'),
    factoryContact: path(ROOTS_HONHAI, '/about-analytics/factory-contact'),
    stationaryPosition: path(ROOTS_HONHAI, '/about-analytics/stationary-position'),
  },
  bulletins: {
    root: path(ROOTS_HONHAI, '/bulletins'),
    news: path(ROOTS_HONHAI, '/bulletins/news'),
    announcements: path(ROOTS_HONHAI, '/bulletins/announcements'),
  },
  documents: {
    root: path(ROOTS_HONHAI, '/documents'),
    order: path(ROOTS_HONHAI, '/documents/order'),
    material: path(ROOTS_HONHAI, '/documents/material'),
  },
  faqs: {
    root: path(ROOTS_HONHAI, '/faqs'),
    affairs: path(ROOTS_HONHAI, '/faqs/affairs'),
    mechanical: path(ROOTS_HONHAI, '/faqs/mechanical'),
    safety: path(ROOTS_HONHAI, '/faqs/safety'),
  },
  contact: {
    root: path(ROOTS_HONHAI, '/contact'),
    us: path(ROOTS_HONHAI, '/contact/us'),
  },
  user: {
    root: path(ROOTS_HONHAI, '/user'),
    profile: path(ROOTS_HONHAI, '/users/profile'),
    edit: (name) => path(ROOTS_HONHAI, `/user/${name}/edit`),
  },
  labor: {
    root: ROOTS_LABOR,
    app: path(ROOTS_LABOR, '/app'),
  },
};

export const PATH_DOCS = '';
